import { BRDGE_PROJECT_ID } from "@/lib/config"

export const useUserStore = defineStore(`user_${BRDGE_PROJECT_ID}`, {
  state: (): {
    id: string | undefined
    token: string | undefined
  } => ({
    id: undefined,
    token: undefined
  }),
  actions: {
    setUser(id: string | undefined, token: string | undefined) {
      this.id = id
      this.token = token
    }
  },
  persist: {
    storage: piniaPluginPersistedstate.cookies({
      maxAge: 31536000, // 365 days,
      sameSite: "strict"
    })
  }
})
